<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add institute</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New institute parameters
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <v-text-field dense color="secondary" 
                                    label="country"
                                    v-model="country" 
                                    name="country" type="text"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="city"
                                    v-model="city" 
                                    name="city" type="text"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="name"
                                    v-model="name" 
                                    name="name" type="text"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="faculty"
                                    v-model="faculty" 
                                    name="faculty" type="text" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <v-text-field dense color="secondary" 
                                    label="contract"
                                     v-model="contract" 
                                    name="contract" type="text"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="price"
                                    v-model.number="price" 
                                    name="price" type="text" 
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-menu ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="10"
                                    :return-value.sync="date_expired"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="120px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field dense
                                            v-model="date_expired"
                                            label="date of expiration"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date_expired" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text small color="secondary"
                                            class="text-lowercase" 
                                            @click="menu = false">
                                            decline
                                        </v-btn>
                                        <v-btn small color="secondary"
                                            class="text-lowercase"
                                            @click="$refs.menu.save(date_expired)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined 
                                    rows="1"
                                    color="secondary"
                                    name="comments" 
                                    label="comments" auto-grou
                                    v-model.lazy="comments">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)"
                    @click="addInstitute">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" 
                    @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddInstitute',
    data() {
        return {
            dialog: false,
            valid: false,
            menu: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            
            //props
            country: '',
            city: '',
            name: '',
            faculty: '',
            contract: '',
            price: 0,
            comments: '',
            date_expired: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },
        onceMore() {
            this.error = ''
            this.calculate = false;
            this.message = '';
        },
        async addInstitute() {

            if (this.$refs.form.validate()) {

                const inst = {
                    country: this.country,
                    city: this.city,
                    name: this.name,
                    faculty: this.faculty,
                    contract: this.contract,
                    price: this.price,
                    comments: this.comments || '',
                    date_expired: this.date_expired,
                }
                console.log(inst);
                try {
                    //add institute 
                    await this.$store.dispatch('addInstitute', inst)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}. You can create only one unique institute`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.menu = false;
            this.$refs.form.reset();
            this.date_expired = new Date().toISOString().substr(0, 10);
        }
    },
}
</script>